/* eslint-disable no-debugger */
import { Fragment, useState } from "react";

import useMeetApprovedInfoForm from "./UseMeetApprovedInfoForm";

import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import DatePicker from "@usas/ui-web/components/datepickers/DatePicker";
import Input from "@usas/ui-web/components/inputs/Input";
import MeetClassificationTreeView from "@usas/ui-web/components/tree/meetClassificationTree/MeetClassificationTreeView";
import CourseMultiSelect from "@usas/ui-web/components/multiSelect/courseMultiSelect/CourseMultiSelect";
import MeetSoftwareDropdown from "@usas/ui-web/components/dropdowns/meetSoftwareDropdown/MeetSoftwareDropdown";
import FacilityLscDropdown from "@usas/ui-web/components/dropdowns/facilityLscDropdown/FacilityLscDropdown";
import Dropdown from "@usas/ui-web/components/dropdowns/Dropdown";
import ReadOnly from "@usas/ui-web/components/readOnly/ReadOnly";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import SearchMemberWithLscPopup from "@usas/ui-web/components/searches/searchMember/SearchMemberWithLscPopup";
import Headings from "@usas/ui-web/components/headings/Headings";

import YesNoSwitch from "@usas/ui-web/components/yesNoSwitch/YesNoSwitch";
import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import style from './MeetApprovedForm.module.css';

const MeetApprovedInfoForm = ({
  handleSubmitProxy,
  onFormValueChanged,
  onValueTextPairChanged,
  formState,
  errorState,
  setFormState,
  setIsDirty,
  savedFormState,
  clubFacilities,
  orgUnitId,
  onCancelClicked,
  state,
  setState,
  meetState,
  hasUsasSanctionAccess }) => {
  const {
    meetFormatState,
    modalState,
    meetSanctionConfigurationState,
    usasClubFacilityLinksState,
    competitionTypeState,
    onModalCancelClicked,
    meetFileUploadState,
    removeFileModalState,
    onUploadTemplateClicked,
    onOpenRemoveFileModalClicked,
    onRemoveFileModalCanceled,
    onRemoveTemplateClicked,
    onDownloadUploadedFile
  } = useMeetApprovedInfoForm({
    formState,
    setFormState,
    setIsDirty,
    savedFormState,
    state,
    setState,
    meetState,
    hasUsasSanctionAccess
  });

  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmitProxy} noValidate>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <Headings.H6>Meet Announcement*</Headings.H6>
          </div>
          <div className="col-xs-12">
            {formState.meetAnnouncementUrl === '' || (formState.meetAnnouncementFileName || '').includes("Bad Request") ?
              <Fragment>
                <label htmlFor="announcement-file-upload" className={global.FileUpload}>
                  Upload File
                </label>
                <input hidden id="announcement-file-upload" type="file" onChange={onUploadTemplateClicked} />
                &nbsp;(*.pdf), (*.doc), or (*.docx)
              </Fragment>
              :
              <Fragment>
                <SecondaryButton onClick={onOpenRemoveFileModalClicked}>Remove Uploaded File</SecondaryButton>&nbsp;
                <PrimaryButton type="button" onClick={(e) => { onDownloadUploadedFile(e) }}>Download Uploaded File</PrimaryButton>
              </Fragment>}
          </div>
          {(formState.meetAnnouncementFileName || '').includes("Bad Request") === false && formState.meetAnnouncementFileName !== '' &&
            <div className="usas-extra-bottom-margin">
              <div className="col-xs-12">
                <p><b>Uploaded File Name:</b> {formState.meetAnnouncementFileName}</p>
              </div>
            </div>
          }
          {(formState.meetAnnouncementFileName || '').includes("Bad Request") === true &&
            <div className="col-xs-12">
              <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
            </div>
          }
          {errorState.meetAnnouncementUrl &&
            <div className="col-xs-12">
              <p className={global.ErrorMessage}>{errorState.meetAnnouncementUrl}</p>
            </div>
          }
          {state.error &&
            <div className="col-xs-12">
              <p className={global.ErrorMessage}>{state?.error ? state?.error : ''}</p>
            </div>
          }
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="Year for Meet Name"
              name="autogeneratedMeetYear"
              value={formState.autogeneratedMeetYear}
            />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Meet Name* (Do not include Year or LSC)"
              name="meetName"
              value={formState.meetName}
              error={errorState.meetName}
              message={errorState.meetName}
              onChange={(value) => { onFormValueChanged('meetName', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <MeetClassificationTreeView
              label="Meet Classification*"
              name="meetClassification"
              value={formState.meetClassification}
              error={errorState.meetClassification}
              message={errorState.meetClassification}
              selectableLeavesOnly={true}
              singleSelect={true}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'meetClassification', newValueLabel, 'meetClassificationName', e); }}
              orgUnitId={orgUnitId || ''}
              filterId={1}
              filterMode={"include_only_filter_id"}
            />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <DatePicker label="Start Date*"
              name="startDate"
              value={formState.startDate}
              error={errorState.startDate}
              message={errorState.startDate}
              onChange={(value) => {
                onFormValueChanged('startDate', value);
                onFormValueChanged('autogeneratedMeetYear', value.toString().substring(6, 10) !== '0000' ? value.toString().substring(6, 10) : '')
              }}
              countOfYears={5}
              startYearOffset={0} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <DatePicker label="End Date*"
              name="endDate"
              value={formState.endDate}
              error={errorState.endDate}
              message={errorState.endDate}
              onChange={(value) => { onFormValueChanged('endDate', value); }}
              countOfYears={5}
              startYearOffset={0} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Dropdown
              label="Facility*"
              name="facilityId"
              value={formState.facilityId}
              error={errorState.facilityId}
              message={errorState.facilityId}
              options={clubFacilities}
              setDefaults={false}
              onChange={(newValue, newValueLabel, e) => {
                onValueTextPairChanged(newValue, 'facilityId', newValueLabel, 'facilityName', e);
                onValueTextPairChanged(Constants.DEFAULT_ID, 'geographicFacilityLscOrgUnitId', '', 'geographicFacilityLscName', e);
              }} />
          </div>
          {formState.facilityId > 0 &&
            <div className="col-xs-12 col-sm-6 col-md-4">
              <FacilityLscDropdown
                label="Geographic Facility LSC*"
                name="geographicFacilityLscOrgUnitId"
                value={formState.geographicFacilityLscOrgUnitId}
                error={errorState.geographicFacilityLscOrgUnitId}
                message={errorState.geographicFacilityLscOrgUnitId}
                facilityId={formState.facilityId}
                setDefaults={false}
                onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'geographicFacilityLscOrgUnitId', newValueLabel, 'geographicFacilityLscName', e); }} />
            </div>
          }
          <div className="col-xs-12 col-sm-6 col-md-4">
            <CourseMultiSelect
              label="Meet Course(s)*"
              name="meetCourse"
              value={formState.meetCourse}
              error={errorState.meetCourse}
              message={errorState.meetCourse}
              onChange={(value) => { onFormValueChanged('meetCourse', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <MeetSoftwareDropdown
              label="Meet Management Software*"
              name="meetSoftwareId"
              value={formState.meetSoftwareId}
              error={errorState.meetSoftwareId}
              message={errorState.meetSoftwareId}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'meetSoftwareId', newValueLabel, 'meetSoftwareName', e); }} />
          </div>
          {meetFormatState.isArrayLoaded &&
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Dropdown
                label="Meet Format*"
                name="meetFormatId"
                value={formState.meetFormatId}
                error={errorState.meetFormatId}
                message={errorState.meetFormatId}
                options={meetFormatState.options}
                isLoading={meetFormatState.isArrayLoading}
                onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'meetFormatId', newValueLabel, 'meetFormatName', e); }} />
            </div>
          }
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Dropdown
              label="Competition Type*"
              name="competitionType"
              value={formState.competitionType}
              error={errorState.competitionType}
              message={errorState.competitionType}
              options={competitionTypeState}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'competitionType', newValueLabel, 'competitionTypeName', e); }} />
            <p>{formState.competitionType === 'Open' ? 'This Approval request requires manual review. Please indicate the reason for hosting this meet as Approved rather than Sanctioned.' : ''}</p>
          </div>
          {formState.competitionType === 'Open' &&
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Open Type as Approved Meet Reason*"
              name="openTypeAsApprovedMeetReason"
              value={formState.openTypeAsApprovedMeetReason}
              error={errorState.openTypeAsApprovedMeetReason}
              message={errorState.openTypeAsApprovedMeetReason}
              onChange={(value) => { onFormValueChanged('openTypeAsApprovedMeetReason', value); }} />
          </div>
          }
        </div>
        <div className="row usas-extra-top-margin" >
          {formState.thisIsMe === false ?
            <div className="col-xs-12 col-sm-6 col-md-4">
              <SearchMemberWithLscPopup label="Payor Member Id*" memberIdName="payorMemberId" formState={formState} errorState={errorState} setFormData={setFormState} onFormValueChanged={onFormValueChanged} />
            </div>
            :
            <div className="col-xs-12 col-sm-6 col-md-4">
              <ReadOnly
                label="Payor Member Id*"
                name="payorMemberId"
                value={formState.payorMemberId}
              />
            </div>
          }
          <div className="col-xs-12 col-sm-4 col-md-4">
            <YesNoSwitch
              label="I am the payor?"
              name="thisIsMe"
              checked={formState.thisIsMe}
              error={errorState.thisIsMe}
              message={errorState.thisIsMe}
              onChange={(value) => { onFormValueChanged('thisIsMe', value); }} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4 col-md-4">
            <YesNoSwitch
              label="Is open water competition?"
              name="isOpenWaterCompetition"
              checked={formState.isOpenWaterCompetition}
              error={errorState.isOpenWaterCompetition}
              message={errorState.isOpenWaterCompetition}
              onChange={(value) => { onFormValueChanged('isOpenWaterCompetition', value); }} />
              <p>
                {formState.isOpenWaterCompetition === true ? (
                  <>
                    This Approval request requires a manual request. Please fill out the OW request form located here{' '}
                    <br /><a href="https://fs22.formsite.com/usaswimming/form108/index.html" target="_blank" rel="noreferrer">OW request form</a>.
                  </>
                ) : ''}
              </p>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4">
            <YesNoSwitch
              label="Is club requesting approval?"
              name="isClubRequestingApproval"
              checked={formState.isClubRequestingApproval}
              error={errorState.isClubRequestingApproval}
              message={errorState.isClubRequestingApproval}
              onChange={(value) => { onFormValueChanged('isClubRequestingApproval', value); }} />
          </div>
        </div>
        <div className={`row usas-extra-top-margin ${style.container}`}>
          <div className={style.header} onClick={toggleExpansion}>
            <span>{isExpanded ? '▲ Collapse' : '▼ Expand'}</span>
          </div>
          <div className={`${style.content} ${isExpanded ? style.expanded : style.collapsed}`}>
            <div className={`${style.contentinner}`}>
              {meetSanctionConfigurationState.isObjLoaded && meetSanctionConfigurationState.objData &&
                <ul style={{ paddingLeft: '10px' }}>
                  {meetSanctionConfigurationState.objData.attestationText
                    .split('+')
                    .filter(item => item.trim() !== '')
                    .map((item, idx) => (
                      <li key={idx} style={{ fontStyle: 'italic', color: '#6c6c6c' }}>
                        {item.trim()}
                      </li>
                    ))}
                </ul>
              }
            </div>
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Attestation Signature*"
              name="attestationSignature"
              value={formState.attestationSignature}
              error={errorState.attestationSignature}
              message={errorState.attestationSignature}
              onChange={(value) => { onFormValueChanged('attestationSignature', value); }} />
          </div>
          <br /><br />
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">Continue</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onCancelClicked}>Back</SecondaryButton>
          </div>
        </div>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={usasClubFacilityLinksState.isArrayLoading} />
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={meetFileUploadState.isObjLoading} />
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title={removeFileModalState.modalTitle}
          displayPopUp={removeFileModalState.displayPopUp}
          onModalCanceled={onRemoveFileModalCanceled}>
          <div className="row">
            <div className="col-xs-12">
              <p><b>File Type:</b> Meet Announcement</p>
              <p><b>Uploaded File Name:</b> {removeFileModalState.fileName}</p>
            </div>
          </div>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              <PrimaryButton type="button" onClick={onRemoveTemplateClicked}>Yes, Remove</PrimaryButton>&nbsp;
              <SecondaryButton type="button" onClick={onRemoveFileModalCanceled}>Cancel</SecondaryButton>
            </div>
          </div>
        </PopUpModal>
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title="Facility Pool Depth Requirement Confirmation"
          displayPopUp={modalState.displayModal}
          onModalCanceled={onModalCancelClicked}>
          <div className="row">
            <div className="col-xs-12">
              <p><b>Facility Name:</b> {modalState.facilityName}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              Please confirm that minimum water depth for racing starts during practice and competition measured for a distance 3 feet 3-1/2 inches (1.0 meter) to 16 feet 5 inches (5.0 meters) from the end wall is at least 4 feet.
              <br />
              <p style={{ fontWeight: 'bold' }}>Selecting &apos;Pool Depth Requirement Met&apos; will update the facility.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <YesNoSwitch
                label="Pool Depth Requirement Met?"
                name="depthRequirementMet"
                checked={formState.depthRequirementMet}
                error={errorState.depthRequirementMet}
                message={errorState.depthRequirementMet}
                onChange={(value) => { onFormValueChanged('depthRequirementMet', value); }}
              />
            </div>
          </div>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              The pool depth confirmation is not required if in-water starts will be used.
              <br />
              <YesNoSwitch
                label="In-Water Start?"
                name="isInWaterStart"
                checked={formState.isInWaterStart}
                error={errorState.isInWaterStart}
                message={errorState.isInWaterStart}
                onChange={(value) => { onFormValueChanged('isInWaterStart', value); }}
              />
            </div>
          </div>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              <SecondaryButton type="button" onClick={onModalCancelClicked}>Continue</SecondaryButton>
            </div>
          </div>
        </PopUpModal>
      </form>
    </Fragment>
  );
};

export default MeetApprovedInfoForm;